import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { events, apiEvents } from 'utils/Api/Api';
import { Url } from 'utils/urls';
import { IsLoggedIn } from 'utils/user';

import { IRouteGuard, IRouteGuardState } from './RouteGuard.model';
import redirectFromOldUrls from './redirectFromOldUrls';

const RouteGuard = ({
  path,
  element,
  authenticatedOnly,
  unauthenticatedOnly,
  authorizedOnly
}: IRouteGuard) => {
  const { state } = useLocation() as {
    state: IRouteGuardState;
  };

  useEffect(() => {
    if (!IsLoggedIn() && authenticatedOnly && element !== null) {
      events.emit(apiEvents.TOKEN_EXPIRED);
    }
  }, [IsLoggedIn()]);

  redirectFromOldUrls();

  if (path === '*') {
    return <Navigate to={Url.notFound} replace />;
  }

  if (IsLoggedIn() && (unauthenticatedOnly || element === null)) {
    return <Navigate to={Url.dashboard} />;
  }

  if (!IsLoggedIn() && authenticatedOnly) {
    return <Navigate to={Url.login} />;
  }

  if (authorizedOnly && !state?.hasAccess) {
    return <Navigate to={Url.notFound} replace />;
  }

  return <Outlet />;
};

export default RouteGuard;
